import React, { useEffect } from 'react'
import { createClassHooks, validate } from '.'
import { Alert } from 'components'
import { WrapCreateAffiliation } from './Style'
import { Form } from 'components/Form'
import { useSelector } from 'react-redux'
import { pulldowns } from 'store/hooks'
import tClass from 'pages/School/CreateClass/hooks'

const CreateClass = () => {
    const formName = "createClass"

    const { roleIndex } = useSelector(state => state.user)
    const { testTaker } = useSelector(state => state.testTaker)
    const { headerFilters } = useSelector(state => state.header)
    const formValues = useSelector(state => state.form[formName]?.values)

    const submitBtns = createClassHooks.useSubmitBtns()
    const setAlert = createClassHooks.useAlert()
    const fields = createClassHooks.useFormFields()

    const createClass = tClass.useCreateClass()

    const handleGroup = pulldowns.useHandleGroup()
    const handleGrade = pulldowns.useHandleGrade()

    useEffect(() => { handleGroup(formValues) }, [formValues?.group, roleIndex])
    useEffect(() => { handleGrade(formValues) }, [formValues?.grade, roleIndex])

    return (
        <Alert
            systemUI
            title={"הוספת כיתה"}
            footerActions={submitBtns}
            handleAlert={() => setAlert(false)}
        >
            <Form
                form={formName}
                title={null}
                validations={(values) => validate(values, testTaker)}
                fields={fields}
                csswrap={WrapCreateAffiliation}
                submit={createClass}
                initialValues={headerFilters}
            // submitBtns={submitBtns}
            />
        </Alert>
    )
}

export default CreateClass